<template>
  <PopUp :show="modal" @hideModal="hideModal">
    <ValidationObserver v-slot="{ invalid }" ref="observer" tag="div" class="memoriam">
      <header class="memoriam__header">
        <h3 class="memoriam__header_title">{{ memoriam.id ? "Edit" : "Add" }} Lives Well Lived</h3>
        <div class="memoriam__header_actions">
          <BaseButton
            v-if="item"
            class="button--sm button--outline button--uppercase"
            text="Delete"
            @click="$emit('removeItem', memoriam)"
          ></BaseButton>
          <BaseButton
            class="button--sm button--green button--uppercase"
            text="Save Changes"
            :loading="changesLoading"
            :disabled="invalid || !changed"
            @click="saveLooseThread"
          ></BaseButton>
        </div>
      </header>
      <div class="form__row">
        <ValidationProvider
          tag="div"
          class="form__row_col"
          :rules="{ required: true, min: 2, max: 255 }"
          v-slot="{ errors }"
        >
          <BaseInput
            placeholder="Name"
            :required="true"
            :validateError="errors[0] || serverError.title"
            v-model="memoriam.title"
            :element="memoriam.title"
            @input="memoriam.title = $event"
          ></BaseInput>
        </ValidationProvider>
      </div>
      <div class="form__row">
        <ValidationProvider
          tag="div"
          class="form__row_col form__row_col--side"
          :rules="{ required: true, min: 4, max: 4, more_then: memoriam.death_year }"
          v-slot="{ errors }"
        >
          <BaseNumberInput
            placeholder="Birth Year"
            :required="true"
            :validateError="errors[0] || serverError.birth_year"
            v-model="memoriam.birth_year"
            :element="memoriam.birth_year"
            @input="memoriam.birth_year = $event"
          ></BaseNumberInput>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="form__row_col form__row_col--side"
          :rules="{ required: true, min: 4, max: 4, less_then: memoriam.birth_year }"
          v-slot="{ errors }"
        >
          <BaseNumberInput
            placeholder="Death Year"
            :required="true"
            :validateError="errors[0] || serverError.death_year"
            v-model="memoriam.death_year"
            :element="memoriam.death_year"
            @input="memoriam.death_year = $event"
          ></BaseNumberInput>
        </ValidationProvider>
      </div>
      <div class="form__row">
        <div class="form__row_col">
          <Editor
            placeholder="Description"
            :value="memoriam.description"
            @input="memoriam.description = $event"
            v-model="memoriam.description"
          ></Editor>
        </div>
      </div>
      <div class="form__row">
        <ValidationProvider
          tag="div"
          class="form__row_col form__row_col--side"
          :rules="{ max: 255 }"
          v-slot="{ errors }"
        >
          <BaseInput
            placeholder="Button Text"
            :validateError="errors[0]"
            v-model="memoriam.button_text"
            :element="memoriam.button_text"
            @input="memoriam.button_text = $event"
          >
          </BaseInput>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="form__row_col form__row_col--side"
          :rules="{ max: 255 }"
          v-slot="{ errors }"
        >
          <BaseInput
            placeholder="Button URL"
            :validateError="errors[0]"
            v-model="memoriam.button_url"
            :element="memoriam.button_url"
            @input="memoriam.button_url = $event"
          >
          </BaseInput>
        </ValidationProvider>
      </div>
    </ValidationObserver>
  </PopUp>
</template>
<script>
import PopUp from "@/components/PopUp.vue";
import BaseButton from "@/components/buttons/BaseButton.vue";
import BaseInput from "@/components/inputs/BaseInput.vue";
import BaseNumberInput from "@/components/inputs/BaseNumberInput.vue";
import Editor from "@/components/inputs/Editor.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapGetters, mapMutations } from "vuex";

export default {
  props: { item: { type: Object, default: null }, modal: { type: Boolean, default: false } },
  components: {
    PopUp,
    BaseButton,
    BaseInput,
    BaseNumberInput,
    Editor,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      url: process.env.VUE_APP_FRONTEND_URL,
      memoriam: {
        title: "",
        birth_year: "",
        death_year: "",
        description: "",
        button_text: "",
        button_url: "",
      },
      changed: false,
    };
  },
  created() {
    if (this.item != null) {
      this.memoriam = JSON.parse(JSON.stringify(this.item));
    }
  },
  beforeDestroy() {
    this.setError(null);
  },
  computed: {
    ...mapGetters("memoriams", {
      serverError: "getServerError",
      changesLoading: "getChangesLoading",
    }),
  },
  watch: {
    memoriam: {
      handler: function (val, oldVal) {
        if (this.item != null) {
          if (this.$refs.observer.flags.dirty) {
            this.changed = true;
          }
        } else {
          this.changed = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("events", ["setError"]),
    hideModal() {
      if (this.changed) {
        this.$swal({
          html: "<h2>Are you sure you want to exit <br/> without saving?</h2>",
          showCancelButton: true,
          cancelButtonText: "Exit without saving",
          confirmButtonText: "Save changes",
        }).then(result => {
          if (result.value) {
            this.$refs.observer.flags.valid ? this.saveLooseThread() : this.showToast();
          } else this.$emit("hideModal");
        });
      } else this.$emit("hideModal");
    },
    showToast() {
      this.$toasted.show(`Please fill in all required fields`, {
        duration: 2000,
        type: "error",
      });
    },
    saveLooseThread() {
      let data = {
        ...this.memoriam,
      };
      if (this.memoriam.id) {
        this.$emit("updateItem", { data });
      } else {
        this.$emit("createItem", { data });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.memoriam {
  height: 100%;
  padding: 0 15px;
  overflow-y: auto;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4rem;
    @media only screen and (max-width: $xs) {
      flex-direction: column;
      align-items: flex-start;
    }
    &_title {
      font-size: 3.35rem;
      font-weight: 600;
      line-height: 1.2;
      text-transform: capitalize;
      color: $black;
    }
    &_actions {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      @media only screen and (max-width: $xs) {
        justify-content: flex-start;
        width: 100%;
      }
      .button {
        margin-left: 10px;
        @media only screen and (max-width: $xs) {
          margin: 20px 10px 0 0;
        }
      }
    }
  }
}
</style>
